export default {
	title: 'settings',
	components: [
		{ title: 'device_name', component: 'device_name_g2' },
		{ title: 'calibration', component: 'calibration_g2' },
		{ title: 'reverse_directions', component: 'reverse_direction_g2' },
		{ title: 'movement_time_limits', component: 'movement_time_limits_g2' },
		{ title: 'action_on_power_on', component: 'action_on_power_on_g2_cover' },
		{ title: 'idle_power_threshold', component: 'idle_power_threshold_g2' },
		{ title: 'idle_confirm_period', component: 'idle_confirm_period_g2' },
		{ title: 'input_type', component: 'input_type_g2_cover' },
		{ title: 'lock_inputs', component: 'lock_inputs_g2' },
		{ title: 'firmware_version', component: 'firmware_update' },
		{ title: 'geo_location_and_time_zone', component: 'location_g2' },
		{ title: 'device_reboot', component: 'device_reboot' },
		{ title: 'factory_reset', component: 'factory_reset' },
		{ title: 'device_information', component: 'device_information' },
	],
};
